import React, { useState, useEffect } from 'react';
import PrescriptionListMobile from './prescriptionListMobile';
import PrescriptionListWeb from './prescriptionListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(0); 

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize(); 
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); 

  return windowWidth;
};

const PrescriptionListRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768; 

  if (width === 0) {
    return null; 
  }

  return width < MOBILE_BREAKPOINT 
    ? <PrescriptionListMobile {...props} /> 
    : <PrescriptionListWeb {...props} />;
};

export default PrescriptionListRouter;